import React, { Component } from "react";
import TournamentCardComponent from "../../Tournaments/TournamentCardComponent";
import loadinggif from "../../../assets/images/loading.gif";

class ChallengesCategoryViewAllComponent extends Component {

  componentDidMount() {
    const { fetchCategoryChallengesViewAllIfNeeded, invalidateAllCategoryChallengesViewAll, page, userId } = this.props;
    invalidateAllCategoryChallengesViewAll();
    fetchCategoryChallengesViewAllIfNeeded({ profileId: userId, page: 1 });
    //fetchCategoryChallengesViewAllIfNeeded({ categoryId: id, page: 1 });
  }
  
  componentDidUpdate() {
    document.body.classList.remove("modal-open");
  }

  render() {
    let { page,userId } = this.props;    
    return (
      <section className="container-fluid my-tournament-wrapper">
        <div className="row">
          <div className="container">
            <div className="padder-main">
              <div className="row d-flex align-items-center mb-30 ">
                <div className="col-8 d-flex justify-content-start">
                  <h2 className="bold">{ this.props.match.params.description } Tournaments</h2>
                </div>
              </div>

              <div className="row card-wrapper d-flex justify-content-center justify-content-sm-start">
                {this.props.ChallengesCategoryViewAll.items.length > 0
                  ? this.props.ChallengesCategoryViewAll.items.map((tournament, i) => (
                      <div className="col-auto mb-4" key={i}>
                        <TournamentCardComponent
                          {...tournament}
                          cardClass="card-my-tournament"
                          brandAvatarClass=""
                          order={i+1}
                        />
                      </div>
                    ))
                  : ""}
              </div>
              <div className="row mb-30 text-center">
                <div className="col-sm-12">
                  {
                    this.props.ChallengesCategoryViewAll.items.length > 0 ? (
                      !this.props.ChallengesCategoryViewAll.isLastPage ? (
                        <button
                          onClick={() => {
                            this.props.invalidateCategoryChallengesViewAll();
                            this.props.fetchCategoryChallengesViewAllIfNeeded({
                              profileId: userId,
                              page: page
                            });
                          }}
                          className="btn btn-pink dark btn-xs"
                        >
                          Load More
                        </button>
                      ) : this.props.ChallengesCategoryViewAll.isFetching ? (
                        <img src={loadinggif} alt="" />
                      ) : (
                        ""
                      )
                    ) : this.props.ChallengesCategoryViewAll.isFetching ? (
                      <img className="text-center" src={loadinggif} alt="" />
                    ) : (
                      <span>No Tournament Found</span>
                    )
                  }

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ChallengesCategoryViewAllComponent;
